var _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "file-code-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.883,
    height: 23.883,
    viewBox: "0 0 23.883 23.883",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M0,0H23.883V23.883H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M15.937,2l4.976,4.976v13.94a.988.988,0,0,1-.988.987H3.988A1,1,0,0,1,3,20.915V2.987A.988.988,0,0,1,3.988,2Zm1.649,9.951-3.52-3.519L12.66,9.842l2.111,2.11-2.11,2.111,1.406,1.408Zm-11.259,0L9.845,15.47l1.407-1.408L9.142,11.951l2.11-2.111L9.846,8.432Z",
    transform: "translate(-0.015 -0.01)",
    fill: "#007b91"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 14.165,
    height: 10.388,
    transform: "translate(4.722 7.829)",
    fill: "#007b91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M5.952,8.674,6.168,6.61H4V5.579H6.277L6.548,3H7.585L7.314,5.579H9.372L9.643,3H10.68l-.271,2.579h1.843V6.61H10.3l-.217,2.063h2.168V9.705H9.975L9.7,12.284H8.667l.271-2.579H6.881L6.61,12.284H5.573l.271-2.579H4V8.674Zm1.037,0H9.047L9.264,6.61H7.206Z",
    transform: "translate(3.814 5.295)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCode);
export default __webpack_public_path__ + "static/media/fileCode.5e4fc4b1e3b3684d82ccd09b20643d62.svg";
export { ForwardRef as ReactComponent };